import { createTheme } from "@mui/material";

//Color references: https://material-ui.com/customization/color/
const arcBlue = "#1565C0";
const arcOrange = "#FF6D00";

// Gradientes dinámicos para diferentes modos
const gradients = {
  light: {
    primary: "linear-gradient(135deg, #1565C0 0%, #1E88E5 100%)",
    secondary: "linear-gradient(135deg, #FF6D00 0%, #FF9E40 100%)",
    hero: "linear-gradient(135deg, rgba(21, 101, 192, 0.06) 0%, rgba(255, 109, 0, 0.06) 100%)",
    card: "linear-gradient(145deg, #ffffff 0%, #f0f4ff 100%)",
    animated: "linear-gradient(45deg, #1565C0, #FF6D00)",
  },
  dark: {
    primary: "linear-gradient(135deg, #0A1628 0%, #1565C0 100%)",
    secondary: "linear-gradient(135deg, #b34d00 0%, #FF6D00 100%)",
    hero: "linear-gradient(135deg, rgba(21, 101, 192, 0.18) 0%, rgba(255, 109, 0, 0.18) 100%)",
    card: "linear-gradient(145deg, #0d1b2a 0%, #1a2a3a 100%)",
    animated: "linear-gradient(45deg, #5b9ef5, #ff9e40)",
  },
};

function handleTheme(darkMode) {
  const mode = darkMode ? "dark" : "light";

  return createTheme({
    palette: {
      mode: mode,
      common: {
        blue: `${arcBlue}`,
        orange: `${arcOrange}`,
      },
      primary: {
        main: "#1565C0",
        light: "#5b9ef5",
        dark: "#0A1628",
        contrastText: "#fff",
      },
      secondary: {
        main: "#FF6D00",
        light: "#ff9e40",
        dark: "#b34d00",
        contrastText: "#fff",
      },
      background: {
        default: darkMode ? "#121212" : "#ffffff",
        paper: darkMode ? "#0d1b2a" : "#fafafa",
      },
      text: {
        primary: darkMode ? "#ffffff" : "#000000",
        secondary: darkMode ? "rgba(255, 255, 255, 0.7)" : "rgba(0, 0, 0, 0.6)",
      },
    },
    // Custom gradients accesibles via theme.gradients
    gradients: gradients[mode],
    // Transiciones globales
    transitions: {
      duration: {
        shortest: 150,
        shorter: 200,
        short: 250,
        standard: 300,
        complex: 375,
        enteringScreen: 225,
        leavingScreen: 195,
      },
      easing: {
        easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
        easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
        easeIn: "cubic-bezier(0.4, 0, 1, 1)",
        sharp: "cubic-bezier(0.4, 0, 0.6, 1)",
        smooth: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
      },
    },
    typography: {
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      h2: { fontWeight: 800, letterSpacing: "-0.02em" },
      h3: { fontWeight: 700, letterSpacing: "-0.01em" },
      h4: { fontWeight: 700, letterSpacing: "-0.01em" },
      h5: { fontWeight: 600 },
      h6: { fontWeight: 600 },
      body1: { lineHeight: 1.7 },
      body2: { lineHeight: 1.6 },
      button: { fontWeight: 600, letterSpacing: "0.02em" },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        sl: 1500,
      },
    },
    // Componentes con transiciones suaves
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            transition: "background-color 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94), color 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
          },
        },
      },
    },
  });
}
export default handleTheme;
